import { storeToRefs } from 'pinia';
import { getStore } from "@/store/index";

// 根据usingStateKey去获取所有的值，并校验表单，适用于通过直接引用组件组成的表单形式
export const useCsrFormValidator = async (refList) => {
    const store = getStore();
	const { csrState } = storeToRefs(store);
	
	const validatorArr = [];
	const data = {};

    refList.forEach(item => {
        const { usingStateKey,validator } = item?.value ?? {};
		validator && validatorArr.push(validator());
		if (usingStateKey) {
			const { value, cmpName, conf={} } = csrState.value[usingStateKey];
			const key = conf?.name ?? cmpName.replace("-", "");
			data[key] = value;
		}
	});
	
	try {
		await Promise.all(validatorArr);

		return Promise.resolve(data);
	} catch (err) {
		return Promise.reject(err);
	}
}
